import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import { Result } from '../Result';
import type { IMultiplePropagationConstraint } from '../../../stores/model/metamodel/multiple_propagation_constraint';

/**
 * Check if the multiple propagation constraint uses the secondary path of an
 * equal to constraint.
 */
class MPCDisabledPathUsageCheck extends Check<IMultiplePropagationConstraint> {
  static description = 'Check for usage of disabled paths';

  check(): Report {
    this.report = new Report();

    const mpc = this.element;

    for (const other of this.model.multiplePropagationConstraints) {
      if (mpc !== other) {
        if (
          other.disablesPath(mpc.primaryPath.elements) ||
          other.disablesPath(mpc.secondaryPath.elements)
        ) {
          this.report.addMessage(
            MessageType.WARNING,
            `MPC uses of the secondary path of ${other.displayString}.`,
            this,
            this.element
          );
        }
      }
    }

    if (this.report.result === Result.NO_RESULT) {
      this.report.addMessage(
        MessageType.INFORMATION,
        `The constraint doesn't use disabled paths.`,
        this,
        this.element
      );
    }

    return this.report;
  }
}

export default MPCDisabledPathUsageCheck;
